/* eslint-disable no-duplicate-case */

const getStatusTextAndStyles = status => {
  const normalizedStatus = (status || '').toLowerCase();
  const mapText = {
    connected: 'Published',
    'not connected': 'Unpublished',
    true: 'True',
    false: 'False',
  };
  switch (normalizedStatus) {
    case 'allow':
    case 'deposit':
    case 'successful':
    case 'completed':
    case 'connected':
    case 'unsigned':
    case 'lending':
    case 'bank_transaction':
    case 'true':
      return {
        styles: 'bg-success20 text-success',
        text: mapText[normalizedStatus] || 'Successful',
        solid: 'text-white bg-success',
      };

    case 'active':
      return {
        styles: 'bg-success20 text-success',
        text: 'Active',
        solid: 'text-white bg-success',
      };
    case 'pending':
    case 'signed':
      return {
        styles: 'bg-[#FFD9512B] text-[#E4B303]',
        text: 'Pending',
        solid: 'text-white bg-warning',
      };

    case 'standard':
    case 'banking':
      return {
        styles: 'bg-[#0B1C56] text-white',
        text: 'Standard',
        solid: 'text-white bg-warning',
      };

    case 'expired':
      return {
        styles: 'bg-[#6507082B] text-[#650708]',
        text: 'Expired',
        solid: 'bg-[#FFD9512B] text-[#E4B303]',
      };

    case 'processing':
    case 'PROCESSING':
    case 'onboarding':
      return {
        styles: 'bg-batchBlue20 text-batchBlue',
        solid: 'bg-batchBlue text-white',
        text: 'Processing',
      };

    case 'transfer':
    case 'failed':
    case 'false':
    case 'block':
    case 'not connected':
      return {
        styles: 'bg-[#A13E3F2B] text-status-404',
        text: mapText[normalizedStatus] || 'Failed',
        solid: 'text-white bg-danger',
      };

    case 'started':
    case 'charge':
      return {
        styles: 'bg-batchBlue20 text-batchBlue',
        solid: 'bg-batchBlue text-white',
        text: 'Created',
      };

    case 'abandoned':
      return {
        styles: 'bg-disabled',
        solid: 'bg-disabled',
        text: 'Abandoned',
      };
    case 'invalidated':
      return {
        styles: 'bg-disabled',
        solid: 'bg-disabled',
        text: 'Invalidated',
      };

    case 'ongoing':
      return {
        styles: 'bg-[#FF681C2B] text-[#FF681C]',
        solid: 'bg-[#FF681C2B] text-[#FF681C]',
        text: 'Ongoing',
      };

    default:
      return {
        styles: 'bg-disabled',
        solid: 'bg-disabled',
        text: 'Unknown',
      };
  }
};

const getStatusWithNumbers = number =>
  ({
    1: 'pending',
    2: 'successful',
    3: 'failed',
  }[number] || 'pending');

export {getStatusTextAndStyles, getStatusWithNumbers};
